(function () {
  'use strict';

  /* ---------- Asset URLs & config (injected via window.jcMapConfig) ---------- */
  var cfg = window.jcMapConfig || {};
  var PIN_REVENDEUR          = cfg.pinRevendeur;
  var PIN_REVENDEUR_SELECTED = cfg.pinRevendeurSelected;
  var PIN_GC                 = cfg.pinGc;
  var PIN_GC_SELECTED        = cfg.pinGcSelected;
  var PIN_CLUSTER            = cfg.pinCluster;
  var CSV_URL  = cfg.csvUrl;
  var MAP_STYLE = cfg.mapStyle;
  var MAP_LAT  = cfg.mapLat;
  var MAP_LNG  = cfg.mapLng;
  var MAP_ZOOM = cfg.mapZoom;

  /* Build a lookup map from lowercase store name → {pin, pinSelected} */
  var PIN_OVERRIDES = {};
  var overrides = cfg.pinOverrides || [];
  for (var o = 0; o < overrides.length; o++) {
    var ov = overrides[o];
    if (ov.name) PIN_OVERRIDES[ov.name] = ov;
  }

  function resolvePin(store, selected) {
    var key = (store.name || '').toLowerCase();
    var ov = PIN_OVERRIDES[key];
    if (ov) return (selected && ov.pinSelected) ? ov.pinSelected : (ov.pin || null);
    if (store.type === 'grand_compte') return selected ? PIN_GC_SELECTED : PIN_GC;
    return selected ? PIN_REVENDEUR_SELECTED : PIN_REVENDEUR;
  }

  /* ---------- State ---------- */
  var map, markerCluster, infoWindow, prevInfoWindow;
  var allStores = [];
  var allMarkers = [];
  var activeMarkerIdx = null;
  var searchOrigin = null;
  var searchQuery = '';
  var currentFilter = 'all';
  var STORES_PER_PAGE = 6;
  var currentPage = 1;

  /* ---------- DOM refs ---------- */
  var $container      = document.getElementById('jc-map-container');
  var $storesList     = document.getElementById('jc-map-stores-list');
  var $storeCount     = document.getElementById('jc-map-store-count');
  var $noResults      = document.getElementById('jc-map-no-results');
  var $storesListWrap = document.querySelector('.jc-map__stores-list-wrap');
  var $storesListScroll = document.querySelector('.jc-map__stores-list-scroll');
  var $searchInput    = document.getElementById('jc-map__search-box');
  var $geolocBtn      = document.getElementById('jc-map-geoloc');
  var $filterTrigger  = document.getElementById('jc-map-filter-trigger');
  var $filterDropdown = document.getElementById('jc-map-filter-dropdown');
  var $filterLabel        = document.getElementById('jc-map-filter-label');
  var $pagination         = document.getElementById('jc-map-pagination');
  var $paginationText     = document.getElementById('jc-map-pagination-text');
  var $paginationFill     = document.getElementById('jc-map-pagination-fill');
  var $paginationBtn      = document.getElementById('jc-map-pagination-btn');
  var $mobilePopup        = document.getElementById('jc-map-mobile-popup');
  var $mobilePopupContent = document.getElementById('jc-map-mobile-popup-content');
  var $mobilePopupClose   = document.getElementById('jc-map-mobile-popup-close');
  var $drawer             = document.getElementById('jc-map-drawer');
  var $drawerContent      = document.getElementById('jc-map-drawer-content');
  var $drawerOverlay      = document.getElementById('jc-map-drawer-overlay');
  var $drawerClose        = document.getElementById('jc-map-drawer-close');

  /* ==========================================================
     Haversine distance (km)
     ========================================================== */
  function haversine(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /* ==========================================================
     Open / Closed status parser
     ========================================================== */
  var DAY_MAP = {
    'lundi': 1, 'mardi': 2, 'mercredi': 3, 'jeudi': 4,
    'vendredi': 5, 'samedi': 6, 'dimanche': 0
  };

  /* ==========================================================
     Timezone resolution
     ========================================================== */
  /* Explicit country names found in CSV addresses → IANA timezone */
  var COUNTRY_TZ = {
    'belgique': 'Europe/Brussels', 'belgium': 'Europe/Brussels',
    'suisse': 'Europe/Zurich', 'switzerland': 'Europe/Zurich',
    'luxembourg': 'Europe/Luxembourg',
    'allemagne': 'Europe/Berlin', 'germany': 'Europe/Berlin',
    'autriche': 'Europe/Vienna', 'wien': 'Europe/Vienna',
    'italie': 'Europe/Rome', 'italy': 'Europe/Rome',
    'espagne': 'Europe/Madrid', 'spain': 'Europe/Madrid',
    'portugal': 'Europe/Lisbon',
    'irlande': 'Europe/Dublin', 'ireland': 'Europe/Dublin',
    'royaume-uni': 'Europe/London', 'uk': 'Europe/London',
    'gr\u00e8ce': 'Europe/Athens', 'greece': 'Europe/Athens',
    'estonie': 'Europe/Tallinn', 'estonia': 'Europe/Tallinn', 'tallinn': 'Europe/Tallinn',
    '\u00e9tats-unis': 'America/New_York', 'etats-unis': 'America/New_York',
    'canada': 'America/Toronto',
    'maroc': 'Africa/Casablanca', 'casablanca': 'Africa/Casablanca', 'rabat': 'Africa/Casablanca',
    's\u00e9n\u00e9gal': 'Africa/Dakar', 'senegal': 'Africa/Dakar', 'dakar': 'Africa/Dakar',
    'guin\u00e9e': 'Africa/Conakry', 'guinea': 'Africa/Conakry', 'conakry': 'Africa/Conakry',
    'nouvelle-cal\u00e9donie': 'Pacific/Noumea', 'noum\u00e9a': 'Pacific/Noumea',
    'r\u00e9union': 'Indian/Reunion',
    'france': 'Europe/Paris'
  };

  /* Bounding boxes [minLng, minLat, maxLng, maxLat] for territories
     whose stores lack an explicit country in their address string */
  var TZ_BOXES = [
    { tz: 'Indian/Reunion',      box: [55.1, -21.5, 55.9, -20.7] },
    { tz: 'America/Martinique',  box: [-61.3, 14.3, -60.8, 14.9] },
    { tz: 'America/Guadeloupe',  box: [-61.9, 15.8, -61.0, 16.6] },
    { tz: 'Pacific/Noumea',      box: [163.5, -22.8, 168.3, -19.5] },
    { tz: 'America/Cayenne',     box: [-54.6, 2.1, -51.6, 5.8] },
    { tz: 'Indian/Mayotte',      box: [44.9, -13.1, 45.4, -12.6] },
    { tz: 'Africa/Casablanca',   box: [-17.2, 27.7, -0.9, 36.0] },
    { tz: 'Africa/Dakar',        box: [-17.5, 12.3, -11.4, 15.1] },
    { tz: 'Africa/Conakry',      box: [-15.1, 7.2, -7.6, 12.7] },
    { tz: 'Europe/Lisbon',       box: [-9.6, 36.8, -6.1, 42.2] },
    { tz: 'Europe/London',       box: [-8.2, 49.9, 2.0, 61.0] },
    { tz: 'Europe/Athens',       box: [20.0, 34.8, 28.3, 42.1] },
    { tz: 'Europe/Tallinn',      box: [21.8, 57.5, 28.2, 59.7] },
    { tz: 'America/Chicago',     box: [-104.1, 28.9, -82.0, 49.4] },
    { tz: 'America/New_York',    box: [-82.0, 24.5, -66.9, 47.5] },
    { tz: 'America/Edmonton',    box: [-120.0, 49.0, -110.0, 60.0] },
    { tz: 'America/Toronto',     box: [-95.2, 41.7, -74.3, 56.9] }
  ];

  function resolveStoreTimezone(address, lat, lng) {
    /* Step 1: check last segment of address for a known country/city name */
    if (address) {
      var segments = address.split(',');
      for (var s = segments.length - 1; s >= Math.max(0, segments.length - 2); s--) {
        var seg = segments[s].trim().toLowerCase().replace(/\s+/g, ' ');
        if (COUNTRY_TZ[seg]) return COUNTRY_TZ[seg];
      }
    }
    /* Step 2: fall back to lat/lng bounding boxes */
    for (var b = 0; b < TZ_BOXES.length; b++) {
      var box = TZ_BOXES[b].box;
      if (lng >= box[0] && lat >= box[1] && lng <= box[2] && lat <= box[3]) {
        return TZ_BOXES[b].tz;
      }
    }
    return 'Europe/Paris';
  }

  /* Get {day, minutes} in any IANA timezone using Intl API */
  function getDateInTimezone(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en', {
        timeZone: tz,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
      }).formatToParts(new Date());
      var WDAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var hour = 0, minute = 0, day = new Date().getDay();
      for (var i = 0; i < parts.length; i++) {
        var t = parts[i].type, v = parts[i].value;
        if (t === 'hour')    hour    = parseInt(v, 10) % 24;
        if (t === 'minute')  minute  = parseInt(v, 10);
        if (t === 'weekday' && WDAY[v] !== undefined) day = WDAY[v];
      }
      return { day: day, minutes: hour * 60 + minute };
    } catch (e) {
      var now = new Date();
      return { day: now.getDay(), minutes: now.getHours() * 60 + now.getMinutes() };
    }
  }

  function parseDayIndex(name) {
    return DAY_MAP[name.trim().toLowerCase()];
  }

  function expandDayRange(text) {
    text = text.trim().toLowerCase();
    var days = [];

    var rangeMatch = text.match(/^(\w+)\s+au\s+(\w+)$/);
    if (rangeMatch) {
      var start = parseDayIndex(rangeMatch[1]);
      var end = parseDayIndex(rangeMatch[2]);
      if (start !== undefined && end !== undefined) {
        var d = start;
        while (true) {
          days.push(d);
          if (d === end) break;
          d = (d + 1) % 7;
        }
      }
      return days;
    }

    var parts = text.split(/\s+et\s+/);
    for (var i = 0; i < parts.length; i++) {
      var idx = parseDayIndex(parts[i]);
      if (idx !== undefined) days.push(idx);
    }
    if (days.length) return days;

    var single = parseDayIndex(text);
    if (single !== undefined) return [single];

    return [];
  }

  function parseTimeSlots(timeStr) {
    var slots = [];
    var parts = timeStr.split(';');
    for (var i = 0; i < parts.length; i++) {
      var match = parts[i].match(/(\d{1,2})[Hh](\d{2})\s*-\s*(\d{1,2})[Hh](\d{2})/);
      if (match) {
        slots.push({
          openH: parseInt(match[1], 10), openM: parseInt(match[2], 10),
          closeH: parseInt(match[3], 10), closeM: parseInt(match[4], 10)
        });
      }
    }
    return slots;
  }

  function getOpenStatus(hoursText, timezone) {
    if (!hoursText) return null;
    var localTime = getDateInTimezone(timezone || 'Europe/Paris');
    var currentDay = localTime.day;
    var currentMinutes = localTime.minutes;

    var entries = hoursText.split(/<br\s*\/?>/i);
    for (var e = 0; e < entries.length; e++) {
      var entry = entries[e].trim();
      if (!entry) continue;

      var colonIdx = entry.indexOf(':');
      if (colonIdx === -1) continue;
      var dayPart = entry.substring(0, colonIdx).trim();
      var timePart = entry.substring(colonIdx + 1).trim();

      var days = expandDayRange(dayPart);
      if (days.indexOf(currentDay) === -1) continue;

      var slots = parseTimeSlots(timePart);
      for (var s = 0; s < slots.length; s++) {
        var open = slots[s].openH * 60 + slots[s].openM;
        var close = slots[s].closeH * 60 + slots[s].closeM;
        if (currentMinutes >= open && currentMinutes < close) {
          return true;
        }
      }
    }
    return false;
  }

  /* ==========================================================
     Hours rows parser
     ========================================================== */
  function parseHoursRows(hoursText) {
    if (!hoursText) return [];
    var rows = [];
    var entries = hoursText.split(/<br\s*\/?>/i);
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i].trim();
      if (!entry) continue;
      var colonIdx = entry.indexOf(':');
      if (colonIdx === -1) continue;
      rows.push({
        days: entry.substring(0, colonIdx).trim(),
        times: entry.substring(colonIdx + 1).trim()
      });
    }
    return rows;
  }

  /* ==========================================================
     Accordion helpers
     ========================================================== */
  function openAccordion(item) {
    var openItems = $storesList.querySelectorAll('.jc-map__store-item.is-open');
    for (var i = 0; i < openItems.length; i++) {
      if (openItems[i] !== item) closeAccordion(openItems[i]);
    }
    var body = item.querySelector('.jc-map__store-body');
    var btn = item.querySelector('.jc-map__store-toggle');
    if (body) body.style.maxHeight = body.scrollHeight + 'px';
    if (btn) btn.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
  }

  function closeAccordion(item) {
    var body = item.querySelector('.jc-map__store-body');
    var btn = item.querySelector('.jc-map__store-toggle');
    if (body) body.style.maxHeight = '0';
    if (btn) btn.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
  }

  /* ==========================================================
     Render store list
     ========================================================== */
  function renderStoreList() {
    var sortedIndices = [];
    for (var i = 0; i < allStores.length; i++) {
      sortedIndices.push(i);
    }

    if (searchOrigin) {
      for (var j = 0; j < allStores.length; j++) {
        allStores[j]._dist = haversine(
          searchOrigin.lat, searchOrigin.lng,
          allStores[j].lat, allStores[j].lng
        );
      }
      sortedIndices.sort(function (a, b) {
        return allStores[a]._dist - allStores[b]._dist;
      });
    }

    var html = '';
    var visibleCount = 0;
    var filteredIndices = [];

    for (var k = 0; k < sortedIndices.length; k++) {
      var idx = sortedIndices[k];
      var store = allStores[idx];
      var storeType = (store.type || 'revendeur').toLowerCase();
      var isVisible = (currentFilter === 'all' || storeType === currentFilter) && matchesSearch(store);
      if (isVisible) filteredIndices.push(idx);
    }

    var totalVisible = filteredIndices.length;
    var isDesktop = window.innerWidth >= 992;
    var maxVisible = isDesktop ? totalVisible : currentPage * STORES_PER_PAGE;
    var showCount = Math.min(maxVisible, totalVisible);

    for (var k = 0; k < showCount; k++) {
      var idx = filteredIndices[k];
      var store = allStores[idx];
      var storeType = (store.type || 'revendeur').toLowerCase();

      var distHtml = '';
      if (searchOrigin && store._dist !== undefined) {
        distHtml = '<span class="jc-map__store-distance">' + store._dist.toFixed(1) + ' km</span>';
      }

      var hoursHtml = '';
      if (store.hours) {
        var openStatus = getOpenStatus(store.hours, store.timezone);
        var statusClass = openStatus ? 'jc-map__store-status--open' : 'jc-map__store-status--closed';
        var statusLabel = openStatus ? 'Ouvert actuellement' : 'Ferm\u00e9';
        var hoursRows = parseHoursRows(store.hours);
        var hoursRowsHtml = '';
        for (var r = 0; r < hoursRows.length; r++) {
          hoursRowsHtml += '<div class="jc-map__store-hours-row">' +
            '<span class="jc-map__store-hours-day">' + hoursRows[r].days + '</span>' +
            '<span class="jc-map__store-hours-sep">:</span>' +
            '<span class="jc-map__store-hours-time">' + hoursRows[r].times.split(';').join('<br>') + '</span>' +
            '</div>';
        }
        hoursHtml = '<div class="jc-map__store-hours">' +
          '<div class="jc-map__store-status ' + statusClass + '">' +
            '<span class="jc-map__store-status-dot"></span>' +
            '<span>' + statusLabel + '</span>' +
          '</div>' +
          '<div class="jc-map__store-hours-list">' + hoursRowsHtml + '</div>' +
          '</div>';
      }

      html += '<div class="jc-map__store-item" data-store-index="' + idx + '" data-store-type="' + storeType + '">' +
        '<div class="jc-map__store-header">' +
          '<span class="jc-map__store-name">' + store.name + '</span>' +
          '<div class="jc-map__store-meta">' +
            distHtml +
            '<button class="jc-map__store-toggle" type="button" aria-label="Voir les d\u00e9tails" aria-expanded="false">' +
              '<svg class="jc-map__toggle-icon jc-map__toggle-icon--plus" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
              '<svg class="jc-map__toggle-icon jc-map__toggle-icon--minus" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        (store.address ? '<div class="jc-map__store-address">' + store.address + '</div>' : '') +
        '<div class="jc-map__store-body">' +
          hoursHtml +
          '<a class="jc-map__store-gmaps" href="https://www.google.com/maps/dir/?api=1&destination=' + store.lat + ',' + store.lng + '" target="_blank" rel="noopener" onclick="event.stopPropagation();">' +
            'Se rendre en boutique' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</a>' +
        '</div>' +
      '</div>';

      visibleCount++;
    }

    $storesList.innerHTML = html;
    visibleCount = showCount;
    $storeCount.textContent = totalVisible + ' boutique' + (totalVisible !== 1 ? 's' : '');

    if (totalVisible === 0) {
      $noResults.classList.add('visible');
      if ($storesListWrap) $storesListWrap.style.display = 'none';
    } else {
      $noResults.classList.remove('visible');
      if ($storesListWrap) $storesListWrap.style.display = '';
    }

    /* Update pagination */
    if ($pagination) {
      if (totalVisible > 0 && showCount < totalVisible) {
        $pagination.classList.add('visible');
        $paginationText.textContent = showCount + ' adresses sur ' + totalVisible;
        $paginationFill.style.width = ((showCount / totalVisible) * 100) + '%';
      } else {
        $pagination.classList.remove('visible');
      }
    }

    var items = $storesList.querySelectorAll('.jc-map__store-item');
    for (var m = 0; m < items.length; m++) {
      (function (item) {
        item.addEventListener('click', function () {
          onStoreItemClick(item);
        });
        var toggleBtn = item.querySelector('.jc-map__store-toggle');
        if (toggleBtn) {
          toggleBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (item.classList.contains('is-open')) {
              closeAccordion(item);
              item.classList.remove('active');
              var storeIdx = parseInt(item.dataset.storeIndex, 10);
              if (activeMarkerIdx === storeIdx) {
                setActiveMarker(null);
                if (prevInfoWindow) prevInfoWindow.close();
              }
            } else {
              openAccordion(item);
            }
          });
        }
      })(items[m]);
    }

    updateScrollbar();
  }

  /* ==========================================================
     Pin icon helpers
     ========================================================== */
  function pinIcon(url) {
    return {
      url: url,
      scaledSize: new google.maps.Size(38, 38),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(19, 19)
    };
  }

  function setActiveMarker(newIdx) {
    if (activeMarkerIdx !== null && allMarkers[activeMarkerIdx]) {
      allMarkers[activeMarkerIdx].setIcon(pinIcon(resolvePin(allStores[activeMarkerIdx], false)));
    }
    if (newIdx !== null && allMarkers[newIdx]) {
      allMarkers[newIdx].setIcon(pinIcon(resolvePin(allStores[newIdx], true)));
    }
    activeMarkerIdx = newIdx;
  }

  /* ==========================================================
     Store item click
     ========================================================== */
  function onStoreItemClick(item) {
    var activeItems = $storesList.querySelectorAll('.jc-map__store-item.active');
    for (var i = 0; i < activeItems.length; i++) {
      activeItems[i].classList.remove('active');
    }

    item.classList.add('active');
    openAccordion(item);

    var storeIdx = parseInt(item.dataset.storeIndex, 10);
    var marker = allMarkers[storeIdx];
    setActiveMarker(storeIdx);
    if (marker && map) {
      map.setCenter(marker.getPosition());
      map.setZoom(14);
      openInfoWindow(storeIdx);
    }

    /* On mobile, switch to map tab so the user sees the result */
    var mapTab = document.querySelector('.jc-map__tab[data-tab="map"]');
    if (mapTab && !mapTab.classList.contains('active')) {
      mapTab.click();
    }
  }

  /* ==========================================================
     Info window
     ========================================================== */
  function openInfoWindow(storeIdx) {
    var store = allStores[storeIdx];
    var marker = allMarkers[storeIdx];
    if (!store || !marker) return;

    if (prevInfoWindow) prevInfoWindow.close();

    var content = '<div class="jc-map__infowindow">' +
      '<div class="jc-map__infowindow-name">' + store.name + '</div>' +
      '<div class="jc-map__infowindow-address">' + (store.address || '') + '</div>' +
      '</div>';

    infoWindow.setContent(content);
    infoWindow.open({ anchor: marker, map: map, shouldFocus: false });
    prevInfoWindow = infoWindow;
  }

  /* ==========================================================
     Mobile bottom sheet popup
     ========================================================== */
  function openMobilePopup(storeIdx) {
    if (!$mobilePopup) return;
    var store = allStores[storeIdx];
    if (!store) return;

    var distHtml = '';
    if (searchOrigin && store._dist !== undefined) {
      distHtml = '<span class="jc-map__store-distance">' + store._dist.toFixed(1) + ' km</span>';
    }

    var hoursHtml = '';
    if (store.hours) {
      var openStatus = getOpenStatus(store.hours, store.timezone);
      var statusClass = openStatus ? 'jc-map__store-status--open' : 'jc-map__store-status--closed';
      var statusLabel = openStatus ? 'Ouvert actuellement' : 'Ferm\u00e9';
      var hoursRows = parseHoursRows(store.hours);
      var hoursRowsHtml = '';
      for (var r = 0; r < hoursRows.length; r++) {
        hoursRowsHtml += '<div class="jc-map__store-hours-row">' +
          '<span class="jc-map__store-hours-day">' + hoursRows[r].days + '</span>' +
          '<span class="jc-map__store-hours-sep">:</span>' +
          '<span class="jc-map__store-hours-time">' + hoursRows[r].times.split(';').join('<br>') + '</span>' +
          '</div>';
      }
      hoursHtml = '<div class="jc-map__store-hours">' +
        '<div class="jc-map__store-status ' + statusClass + '">' +
          '<span class="jc-map__store-status-dot"></span>' +
          '<span>' + statusLabel + '</span>' +
        '</div>' +
        '<div class="jc-map__store-hours-list">' + hoursRowsHtml + '</div>' +
        '</div>';
    }

    $mobilePopupContent.innerHTML =
      '<div class="jc-map__store-header">' +
        '<span class="jc-map__store-name">' + store.name + '</span>' +
        distHtml +
      '</div>' +
      (store.address ? '<div class="jc-map__store-address">' + store.address + '</div>' : '') +
      hoursHtml +
      '<a class="jc-map__store-gmaps" href="https://www.google.com/maps/dir/?api=1&destination=' + store.lat + ',' + store.lng + '" target="_blank" rel="noopener">' +
        'Se rendre en boutique' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</a>';

    $mobilePopup.classList.add('is-visible');
    $mobilePopup.setAttribute('aria-hidden', 'false');
  }

  function closeMobilePopup() {
    if (!$mobilePopup) return;
    $mobilePopup.classList.remove('is-visible');
    $mobilePopup.setAttribute('aria-hidden', 'true');
    setActiveMarker(null);
    var activeItems = $storesList.querySelectorAll('.jc-map__store-item.active');
    for (var i = 0; i < activeItems.length; i++) {
      closeAccordion(activeItems[i]);
      activeItems[i].classList.remove('active');
    }
    if (prevInfoWindow) prevInfoWindow.close();
  }

  /* ==========================================================
     Desktop drawer (right panel)
     ========================================================== */
  function openDrawer(html) {
    if (!$drawer || !$drawerContent) return;
    $drawerContent.innerHTML = html;
    $drawer.classList.add('is-visible');
    $drawer.setAttribute('aria-hidden', 'false');
    if ($drawerOverlay) $drawerOverlay.classList.add('is-visible');
  }

  function closeDrawer() {
    if (!$drawer) return;
    $drawer.classList.remove('is-visible');
    $drawer.setAttribute('aria-hidden', 'true');
    if ($drawerOverlay) $drawerOverlay.classList.remove('is-visible');
    setActiveMarker(null);
    var activeItems = $storesList.querySelectorAll('.jc-map__store-item.active');
    for (var i = 0; i < activeItems.length; i++) {
      closeAccordion(activeItems[i]);
      activeItems[i].classList.remove('active');
    }
    if (prevInfoWindow) prevInfoWindow.close();
  }

  if ($drawerClose) $drawerClose.addEventListener('click', closeDrawer);
  if ($drawerOverlay) $drawerOverlay.addEventListener('click', closeDrawer);

  /* ==========================================================
     Marker click → scroll sidebar
     ========================================================== */
  function onMarkerClick(storeIdx) {
    setActiveMarker(storeIdx);
    openInfoWindow(storeIdx);

    if (window.innerWidth < 992) {
      openMobilePopup(storeIdx);
    }

    var item = $storesList.querySelector('[data-store-index="' + storeIdx + '"]');
    if (item) {
      var activeItems = $storesList.querySelectorAll('.jc-map__store-item.active');
      for (var i = 0; i < activeItems.length; i++) activeItems[i].classList.remove('active');
      item.classList.add('active');
      openAccordion(item);
      item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ==========================================================
     Text search filter
     ========================================================== */
  function matchesSearch(store) {
    if (!searchQuery) return true;
    var q = searchQuery.toLowerCase();
    return (store.name && store.name.toLowerCase().indexOf(q) !== -1) ||
           (store.address && store.address.toLowerCase().indexOf(q) !== -1);
  }

  /* ==========================================================
     Filter
     ========================================================== */
  function applyFilter(filterValue) {
    currentFilter = filterValue;
    currentPage = 1;

    if (markerCluster) {
      markerCluster.clearMarkers();
      var visibleMarkers = [];
      for (var i = 0; i < allStores.length; i++) {
        var storeType = (allStores[i].type || 'revendeur').toLowerCase();
        var visible = (currentFilter === 'all' || storeType === currentFilter) && matchesSearch(allStores[i]);
        if (visible) visibleMarkers.push(allMarkers[i]);
      }
      markerCluster.addMarkers(visibleMarkers);
    }

    renderStoreList();
  }

  /* ==========================================================
     Set origin (search or geolocation)
     ========================================================== */
  function setOrigin(lat, lng) {
    searchOrigin = { lat: lat, lng: lng };
    currentPage = 1;
    map.setCenter(searchOrigin);
    map.setZoom(10);
    renderStoreList();
  }

  /* ==========================================================
     Custom scrollbar
     ========================================================== */
  var $scrollbar  = document.getElementById('jc-map-scrollbar');
  var $scrollThumb = document.getElementById('jc-map-scrollbar-thumb');
  var isDragging = false;
  var dragStartY = 0;
  var dragStartScrollTop = 0;

  function updateScrollbar() {
    if (!$scrollbar || !$scrollThumb || !$storesListScroll) return;
    var scrollHeight = $storesListScroll.scrollHeight;
    var clientHeight = $storesListScroll.clientHeight;
    if (scrollHeight <= clientHeight) {
      $scrollbar.style.display = 'none';
      return;
    }
    $scrollbar.style.display = 'block';
    var thumbRatio = clientHeight / scrollHeight;
    var thumbHeight = Math.max(thumbRatio * clientHeight, 40);
    var maxThumbTop = clientHeight - thumbHeight;
    var thumbTop = ($storesListScroll.scrollTop / (scrollHeight - clientHeight)) * maxThumbTop;
    $scrollThumb.style.height = thumbHeight + 'px';
    $scrollThumb.style.transform = 'translateY(' + thumbTop + 'px)';
  }

  if ($storesListScroll) {
    $storesListScroll.addEventListener('scroll', updateScrollbar);
  }

  if ($scrollThumb) {
    $scrollThumb.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragStartY = e.clientY;
      dragStartScrollTop = $storesListScroll.scrollTop;
      document.body.style.userSelect = 'none';
      e.preventDefault();
    });
  }

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var scrollHeight = $storesListScroll.scrollHeight;
    var clientHeight = $storesListScroll.clientHeight;
    var thumbHeight = parseFloat($scrollThumb.style.height) || 40;
    var maxThumbTop = clientHeight - thumbHeight;
    var delta = e.clientY - dragStartY;
    var scrollRatio = delta / maxThumbTop;
    $storesListScroll.scrollTop = dragStartScrollTop + scrollRatio * (scrollHeight - clientHeight);
  });

  document.addEventListener('mouseup', function () {
    if (isDragging) {
      isDragging = false;
      document.body.style.userSelect = '';
    }
  });

  if ($scrollbar) {
    $scrollbar.addEventListener('click', function (e) {
      if (e.target === $scrollThumb) return;
      var rect = $scrollbar.getBoundingClientRect();
      var clickY = e.clientY - rect.top;
      var clientHeight = $storesListScroll.clientHeight;
      var scrollHeight = $storesListScroll.scrollHeight;
      var thumbHeight = parseFloat($scrollThumb.style.height) || 40;
      var clickRatio = (clickY - thumbHeight / 2) / (clientHeight - thumbHeight);
      $storesListScroll.scrollTop = clickRatio * (scrollHeight - clientHeight);
    });
  }

  /* ==========================================================
     Mobile tabs
     ========================================================== */
  function initMobileTabs() {
    var tabs = document.querySelectorAll('.jc-map__tab');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        var tabName = this.dataset.tab;

        for (var j = 0; j < tabs.length; j++) {
          tabs[j].classList.remove('active');
        }
        this.classList.add('active');

        $container.classList.remove('tab-map', 'tab-list');
        $container.classList.add('tab-' + tabName);

        if (tabName === 'map' && map) {
          google.maps.event.trigger(map, 'resize');
        }

        if (tabName === 'list') {
          closeMobilePopup();
        }
      });
    }
  }

  /* ==========================================================
     Init Map (called by Google Maps callback)
     ========================================================== */
  window.initJcMap = function () {
    map = new google.maps.Map(document.getElementById('jc-map'), {
      zoom: MAP_ZOOM,
      center: { lat: MAP_LAT, lng: MAP_LNG },
      styles: MAP_STYLE,
      mapTypeControl: false
    });

    infoWindow = new google.maps.InfoWindow();

    infoWindow.addListener('closeclick', function () {
      setActiveMarker(null);
      var activeItems = $storesList.querySelectorAll('.jc-map__store-item.active');
      for (var i = 0; i < activeItems.length; i++) {
        closeAccordion(activeItems[i]);
        activeItems[i].classList.remove('active');
      }
    });

    var mcOptions = {
      styles: [
        { height: 53, url: PIN_CLUSTER, width: 53 },
        { height: 56, url: PIN_CLUSTER, width: 56 },
        { height: 66, url: PIN_CLUSTER, width: 66 },
        { height: 78, url: PIN_CLUSTER, width: 78 },
        { height: 90, url: PIN_CLUSTER, width: 90 }
      ]
    };

    Papa.parse(CSV_URL, {
      download: true,
      header: true,
      complete: function (result) {
        var locations = result.data;

        for (var i = 0; i < locations.length; i++) {
          var row = locations[i];
          if (!row.lat || !row.lng) continue;

          /* Note: CSV has lat/lng swapped in existing data */
          var storeLat = Number(row.lng);
          var storeLng = Number(row.lat);

          if (isNaN(storeLat) || isNaN(storeLng)) continue;

          var storeType = (row.Type || 'revendeur').trim().toLowerCase();

          var store = {
            lat: storeLat,
            lng: storeLng,
            name: row.Name || '',
            description: row.Description || '',
            address: row.Address || '',
            hours: row.Hours || '',
            category: row.Category || '',
            type: storeType,
            timezone: resolveStoreTimezone(row.Address || '', storeLat, storeLng),
            _index: allStores.length
          };
          allStores.push(store);

          var icon = {
            url: resolvePin(store, false),
            scaledSize: new google.maps.Size(38, 38),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(19, 19)
          };

          var marker = new google.maps.Marker({
            position: { lat: storeLat, lng: storeLng },
            title: store.name,
            icon: icon
          });

          (function (idx) {
            marker.addListener('click', function () {
              onMarkerClick(idx);
            });
          })(store._index);

          allMarkers.push(marker);
        }

        markerCluster = new MarkerClusterer(map, allMarkers, mcOptions);
        renderStoreList();
      }
    });

    $searchInput.addEventListener('input', function () {
      searchQuery = this.value.trim();
      applyFilter(currentFilter);
    });

    var $searchBtn = document.querySelector('.jc-map__search-btn');
    if ($searchBtn) {
      $searchBtn.addEventListener('click', function () {
        searchQuery = $searchInput.value.trim();
        applyFilter(currentFilter);
      });
    }

    $searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        searchQuery = this.value.trim();
        applyFilter(currentFilter);
      }
    });

    $geolocBtn.addEventListener('click', function () {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(function (position) {
        setOrigin(position.coords.latitude, position.coords.longitude);
      }, function () {
        infoWindow.setPosition(map.getCenter());
        infoWindow.setContent('Impossible d\'acc\u00e9der \u00e0 votre position.');
        infoWindow.open(map);
      });
    });

    $filterTrigger.addEventListener('click', function () {
      $filterDropdown.classList.toggle('open');
      $filterTrigger.classList.toggle('open');
    });

    var radios = $filterDropdown.querySelectorAll('input[type="radio"]');
    for (var r = 0; r < radios.length; r++) {
      radios[r].addEventListener('change', function () {
        var labels = { all: 'Tous boutiques', revendeur: 'Revendeur', grand_compte: 'Grand Compte' };
        $filterLabel.textContent = labels[this.value] || this.value;
        $filterDropdown.classList.remove('open');
        $filterTrigger.classList.remove('open');
        applyFilter(this.value);
      });
    }

    if ($mobilePopupClose) {
      $mobilePopupClose.addEventListener('click', closeMobilePopup);
    }

    if ($paginationBtn) {
      $paginationBtn.addEventListener('click', function () {
        var prevCount = currentPage * STORES_PER_PAGE;
        currentPage++;
        renderStoreList();
        var items = $storesList.querySelectorAll('.jc-map__store-item');
        if (items.length > prevCount) {
          var target = items[prevCount];
          $storesList.scrollTo({ top: target.offsetTop - $storesList.offsetTop, behavior: 'smooth' });
        }
      });
    }

    initMobileTabs();
  };

  window.jcMapShowStore = function (data) {
    if (!data || !data.name) return;

    // Build hours HTML
    var hoursHtml = '';
    if (data.hours) {
      var openStatus = getOpenStatus(data.hours, data.timezone || '');
      var statusClass = openStatus ? 'jc-map__store-status--open' : 'jc-map__store-status--closed';
      var statusLabel = openStatus ? 'Ouvert actuellement' : 'Ferm\u00e9';
      var hoursRows = parseHoursRows(data.hours);
      var hoursRowsHtml = '';
      for (var r = 0; r < hoursRows.length; r++) {
        hoursRowsHtml += '<div class="jc-map__store-hours-row">' +
          '<span class="jc-map__store-hours-day">' + hoursRows[r].days + '</span>' +
          '<span class="jc-map__store-hours-sep">:</span>' +
          '<span class="jc-map__store-hours-time">' + hoursRows[r].times.split(';').join('<br>') + '</span>' +
          '</div>';
      }
      hoursHtml = '<div class="jc-map__store-hours">' +
        '<div class="jc-map__store-status ' + statusClass + '">' +
          '<span class="jc-map__store-status-dot"></span>' +
          '<span>' + statusLabel + '</span>' +
        '</div>' +
        '<div class="jc-map__store-hours-list">' + hoursRowsHtml + '</div>' +
        '</div>';
    }

    var gmapsHtml = '';
    if (data.lat && data.lng) {
      gmapsHtml = '<a class="jc-map__store-gmaps" href="https://www.google.com/maps/dir/?api=1&destination=' + data.lat + ',' + data.lng + '" target="_blank" rel="noopener">' +
        'Se rendre en boutique' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</a>';
    }

    var popupHtml =
      '<div class="jc-map__store-header">' +
        '<span class="jc-map__store-name">' + data.name + '</span>' +
      '</div>' +
      (data.address ? '<div class="jc-map__store-address">' + data.address + '</div>' : '') +
      hoursHtml +
      gmapsHtml;

    if (window.innerWidth < 992) {
      // Mobile: switch to map tab + open bottom sheet
      var mapTab = document.querySelector('.jc-map__tab[data-tab="map"]');
      if (mapTab && !mapTab.classList.contains('active')) mapTab.click();
      if ($mobilePopupContent && $mobilePopup) {
        $mobilePopupContent.innerHTML = popupHtml;
        $mobilePopup.classList.add('is-visible');
        $mobilePopup.setAttribute('aria-hidden', 'false');
      }
    } else {
      // Desktop: open right drawer
      openDrawer(popupHtml);
    }
  };

})();
